import { BackendModel, BackendService } from '../../core/backend.service';
import { CategoriaProducto } from '../categoria-producto/categoria-producto.model';
import { Sugerencia } from '../sugerencia/sugerencia.model';

export class SubcategoriaProducto extends BackendModel {

  static path = '/productos/subcategorias/';

  id: number;
  description: string;
  origen: string;
  categorias?: CategoriaProducto[];
  sugerencias?: Sugerencia[];

  constructor(protected backendService: BackendService, model?: SubcategoriaProducto) {
    super(backendService, model);
  }

  interna(): boolean {
    return this.origen === CategoriaProducto.codInterna;
  }

  get sugerenciaString() {
    let s = '';
    this.sugerencias.forEach(v => s += v.description + ', ');
    s = s.length > 100 ? s.substr(0, 100) + '[...]' : s.substr(0, s.length - 2);
    return s;
  }

  get categoriaString() {
    let s = '';
    this.categorias.forEach(v => s += v.description + ', ');
    s = s.length > 100 ? s.substr(0, 100) + '[...]' : s.substr(0, s.length - 2);
    return s;
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/subcategoria-producto/subcategoria-producto.model.ts